// extracted by mini-css-extract-plugin
export var bodyMargin = "styles-module--bodyMargin--12fa5";
export var cardTitles = "styles-module--cardTitles--2c5ba";